/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import {
  Image,
  Button,
  Container,
  Navbar,
  Nav,
  NavDropdown,
} from "react-bootstrap";
import { Divider } from "react-native-elements/dist/divider/Divider";
import { HashLink } from "react-router-hash-link";
import "./styles.css";
import { StorageModule } from "@vlinder-web/storage-module-react";

export interface INavItemProps {
  name: string;
  link?: string;
}

export interface IHeaderCompProps {
  headerLogo?: string;
  headerLink?: string;
  headerTitle?: string;
  headerTitleStyle?: any;
  navItems?: INavItemProps[];
  buttonItem?: {
    name: string;
    link: string;
  };
  isButtonItem1?: boolean;
  buttonItem1?: {
    name: string;
    link: string;
  };
}

export const HeaderComp = ({
  headerLogo,
  headerLink,
  headerTitle,
  headerTitleStyle,
  navItems,
  buttonItem,
  buttonItem1,
  isButtonItem1,
}: IHeaderCompProps) => {
  const storageSrv = StorageModule?.getInstance();
  function isValidHttpUrl(string: string) {
    let url;

    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
  }

  const _renderBrandLogo = () => {
    if (headerLogo) {
      return (
        <Navbar.Brand
          as={HashLink}
          to={
            isValidHttpUrl(headerLink) ? { pathname: headerLink } : headerLink
          }
          target={isValidHttpUrl(headerLink) ? "_blank" : "_self"}
          className="me-lg-3 d-flex align-items-center"
        >
          <Image src={headerLogo} />
          {headerTitle && (
            <span
              className="ms-2 brand-text d-none d-md-inline"
              style={headerTitleStyle}
            >
              {headerTitle}
            </span>
          )}
        </Navbar.Brand>
      );
    }
  };

  const _getNavItem = (item, index) => {
    if (item?.type === "collapsable") {
      return (
        <NavDropdown title={item?.name} id="nav-dropdown">
          {item?.children?.map((key, i) => {
            return (
              <NavDropdown.Item
                eventKey={`header-nav-dropdown-${i}-${index}`}
                as={HashLink}
                to={key?.link ?? "#"}
                style={{ fontWeight: 500 }}
              >
                {key?.name}
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>
      );
    } else {
      return (
        <Nav.Link
          key={`header-navbar-link-item-${index}`}
          as={HashLink}
          to={item?.link ?? "#"}
          className="font-weight-bold"
          style={{ fontWeight: 500 }}
        >
          {item.name}
        </Nav.Link>
      );
    }
  };

  const _renderNavItems = () => {
    return (
      <div className="d-flex align-items-center">
        <Navbar.Toggle />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="navbar-nav-hover align-items-lg-center me-auto">
            {navItems?.map((item, index) => _getNavItem(item, index))}
          </Nav>
        </Navbar.Collapse>
        {buttonItem && (
          <Button
            // as={HashLink}
            // to={buttonItem?.link}
            onClick={() => window.open(buttonItem?.link, "_self")}
            variant="outline-primary"
            className="ms-3"
          >
            {buttonItem?.name}
          </Button>
        )}
        {buttonItem1 && isButtonItem1 && (
          <Button
            // as={HashLink}
            // to={buttonItem?.link}
            onClick={() => {
              storageSrv.reset("session");
              storageSrv.reset("local");
              window.open(buttonItem1?.link, "_self");
            }}
            variant="outline-primary"
            className="ms-3"
          >
            {buttonItem1?.name}
          </Button>
        )}
      </div>
    );
  };
  return (
    <>
      <Navbar
        collapseOnSelect
        variant="light"
        expand="md"
        bg="light"
        className="navbar-theme-gray sticky-top navbar navbar-theme-white navbar-light bg-light d-xs-none"
      >
        <Container className="position-relative justify-content-between px-3">
          {_renderBrandLogo()}
          {_renderNavItems()}
        </Container>
      </Navbar>
      <Divider />
    </>
  );
};

HeaderComp.defaultProps = {
  headerLink: "#home",
};
